import Image from 'next/image';

import styles from './Footer.module.scss';

/*
 * https://cdn-nurse-senka-assets.nurse-senka.jp/img/common/privacy_mark.webp が閲覧出来ない場合
 * AWSの s3://prd-nurse-senka-assets/img/common/ に src/components/Footer/privacy_mark.webp をアップロードしてください
 */
export const PrivacyMark = () => (
  <a
    className={styles['privacy-mark']}
    href="http://privacymark.jp"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Image
      src="https://cdn-nurse-senka-assets.nurse-senka.jp/img/common/privacy_mark.webp"
      alt="PrivacyMark"
      width={60}
      height={60}
    />
  </a>
);
